/* 平台下单 */
<template>
  <div id="orderForm">

    <div class="orderForm-header" @click="$router.back()">
      <i class="el-icon-arrow-left"></i> 返回
    </div>

    <el-form :model="form" :rules="rules" ref="form" label-width="90px" label-position="left" style="margin-bottom:0">

      <div class="orderForm-title">
        <div class="title-left">
          <i class="el-icon-edit-outline title-icon"></i>
          <div>
            <span class="title-text">代客下单</span>
            <span class="title-sub">管理员代乘客购票，下单后乘客收到行程短信</span>
          </div>
        </div>
        <el-button type="primary" plain size="small" icon="el-icon-refresh" @click="refresh" :loading="linesLoading">刷新线路</el-button>
      </div>

      <div class="notice-bar">
        <i class="el-icon-info-solid"></i>
        仅可选择本机构下的线路进行下单，总机构可看到所有分机构线路
      </div>

      <el-form-item label="选择线路" prop="lineId">
        <el-select v-model="form.lineId" @change="lineChange" filterable
          :placeholder="linesLoading ? '线路加载中...' : lines && lines.length > 0 ? '请搜索或选择线路' : '当前机构暂无可用线路'"
          :loading="linesLoading"
          style="width:100%">
          <el-option v-for="(item) in lines" :key="item.id"
            :value="item.id"
            :disabled="item.schedulingType == 3"
            :label="item.startStationName + ' → ' + item.endStationName">
            <div class="line-option">
              <div class="line-option-main">
                <span class="line-name">{{ item.startStationName }} → {{ item.endStationName }}</span>
                <el-tag v-if="item.schedulingType == 3" size="mini" type="info">不支持下单</el-tag>
                <el-tag v-else-if="lineScheduleMap[item.id] && lineScheduleMap[item.id].total === 0" size="mini" type="danger">今日无班次</el-tag>
                <el-tag v-else-if="lineScheduleMap[item.id] && lineScheduleMap[item.id].total > 0" size="mini" type="success">{{ lineScheduleMap[item.id].total }}个班次</el-tag>
                <el-tag v-else-if="scheduleMapLoading" size="mini" type="info">加载中</el-tag>
              </div>
              <div class="line-option-sub" v-if="lineScheduleMap[item.id] && lineScheduleMap[item.id].total > 0">
                <span class="line-fee">￥{{ item.fee }}{{ item.railType == 2 ? '起' : '' }}</span>
                <span class="line-seats" :class="{ 'low-seats': lineScheduleMap[item.id].remaining < 5 }">
                  余{{ lineScheduleMap[item.id].remaining }}座
                </span>
              </div>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 选中线路后的班次摘要卡片 -->
      <div class="schedule-summary" v-if="form.lineId && scheduleSummary">
        <div class="summary-header">
          <i class="el-icon-date"></i>
          <span>今日可用班次</span>
        </div>
        <div v-if="scheduleSummary.total === 0" class="summary-empty">
          <i class="el-icon-warning-outline"></i>
          今日该线路暂无可用班次，请选择其他线路或稍后再试
        </div>
        <div v-else class="summary-list">
          <div class="summary-item" v-for="s in scheduleSummary.items" :key="s.id"
            :class="{ 'item-disabled': s.ticketNumType == 2 && !s.remainingTickets }"
            @click="form.schedulingId !== s.id && !( s.ticketNumType == 2 && !s.remainingTickets ) && quickSelectScheduling(s)">
            <div class="summary-item-time">
              <span class="time-badge">{{ s.startTime }} - {{ s.endTime }}</span>
              <el-tag size="mini" :type="s.ticketNumType == 2 && !s.remainingTickets ? 'info' : 'success'" effect="plain">
                {{ s.ticketNumType == 1 ? '不限购' : s.remainingTickets > 0 ? '余 ' + s.remainingTickets + ' 座' : '已售罄' }}
              </el-tag>
              <el-tag v-if="s.isCompensateTicket == 1 && s.status == 2" size="mini" type="warning" effect="plain">可补票</el-tag>
            </div>
            <div class="summary-item-date">{{ $utils.timeFn(s.schedulingTime, 'MM/DD') }}</div>
            <el-tag v-if="form.schedulingId === s.id" size="mini" type="primary">已选</el-tag>
          </div>
        </div>
      </div>

      <el-form-item label="选择班次" prop="schedulingId" :rules="schedulings && schedulings.length < 1 && form.lineId
        ? [{ required: true, message: '该线路暂无可用班次，请切换其他线路', trigger: ['blur', 'change'] }]
        : [{ required: true, message: '请选择出行班次', trigger: ['blur', 'change'] }]
        ">
        <el-select v-model="form.schedulingId" @change="schedulingChange" @focus="schedulingFocus"
          :disabled="!form.lineId || (schedulings && schedulings.length < 1 && !!form.lineId)"
          :placeholder="!form.lineId ? '请先选择线路' : schedulings && schedulings.length < 1 ? '该线路今日无可用班次' : '请选择出行班次'"
          style="width:100%">
          <el-option v-for="(item) in schedulings" :key="item.id"
            :disabled="item.ticketNumType == 2 && !item.remainingTickets"
            :label="item.intercityName
              ? `【专线包车】${item.intercityName} · ${item.startTime}-${item.endTime} · ￥${item.serviceFee}`
              : `${$utils.timeFn(item.schedulingTime, 'MM/DD')} ${item.startTime}-${item.endTime} · ${item.ticketNumType == 1 ? '不限购' : '余' + item.remainingTickets + '座'}`"
            :value="item.id">
            <div class="scheduling-option">
              <template v-if="item.intercityName">
                <div class="sch-main">
                  <el-tag size="mini" type="warning" style="margin-right:6px">专线包车</el-tag>
                  <span class="sch-name">{{ item.intercityName }}</span>
                </div>
                <div class="sch-sub">
                  <span>{{ item.startTime }} - {{ item.endTime }}</span>
                  <span class="sch-fee">￥{{ item.serviceFee }}</span>
                </div>
              </template>
              <template v-else>
                <div class="sch-main">
                  <span class="sch-date">{{ $utils.timeFn(item.schedulingTime, 'MM/DD') }}</span>
                  <span class="sch-time">{{ item.startTime }} - {{ item.endTime }}</span>
                  <el-tag v-if="item.isCompensateTicket == 1 && item.status == 2" size="mini" type="warning" effect="plain">补票</el-tag>
                </div>
                <div class="sch-sub">
                  <span class="sch-seat" :class="{ 'seat-low': item.remainingTickets > 0 && item.remainingTickets < 5, 'seat-out': item.ticketNumType == 2 && !item.remainingTickets }">
                    {{ item.ticketNumType == 1 ? '不限购' : item.remainingTickets > 0 ? '余 ' + item.remainingTickets + ' 座' : '已售罄' }}
                  </span>
                  <span class="sch-fee">￥{{ lineInfo.railType == 2 ? lineInfo.fee + '起' : lineInfo.fee }}</span>
                </div>
              </template>
            </div>
          </el-option>
        </el-select>
        <span class="el-form-item-remark">可选择售票中班次，或停售班次进行补票操作</span>
      </el-form-item>

      <el-form-item v-if="orderType == 2" label="用车时间" prop="rentTimeValueArr">
        <div class="time">
          <el-select v-model="rentTimeValueArr[0]" placeholder="选择日期">
            <el-option v-for="(item, index) in days" :key="item" :label="item" :value="index">
            </el-option>
          </el-select>

          <el-select v-model="rentTimeValueArr[1]" @change="rentTimeChange" placeholder="选择时间">
            <el-option v-for="(item, index) in hours" :key="item" :label="item + '时'" :value="index">
            </el-option>
          </el-select>

          <el-select v-model="rentTimeValueArr[2]" placeholder="选择时间">
            <el-option v-for="(item, index) in minutes" :key="item" :label="item + '分'" :value="index">
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="上车位置" prop="startAddress">
        <span style="font-size: 14px" v-if="lineInfo.lineType == 1 || lineInfo.lineType == 2">{{ startAddress }}</span>
        <el-button v-else :disabled="!form.lineId || !form.schedulingId" @click="changeAddress(1)" type="text">
          {{ startAddress ? startAddress : "点击选择" }}
        </el-button>
      </el-form-item>

      <el-form-item label="下车位置" prop="endAddress">
        <span style="font-size: 14px" v-if="lineInfo.lineType == 1 || lineInfo.lineType == 4">{{ endAddress }}</span>
        <el-button v-else :disabled="!form.lineId" @click="changeAddress(2)" type="text">
          {{ endAddress ? endAddress : "点击选择" }}
        </el-button>
      </el-form-item>

      <!-- 历史乘客快捷搜索 -->
      <template v-if="form.schedulingId">
        <div class="history-customer-search">
          <div class="history-search-label">历史乘客快捷选填</div>
          <el-autocomplete
            v-model="historyKeyword"
            :fetch-suggestions="searchHistoryCustomers"
            placeholder="输入姓名或手机号搜索历史乘客"
            :trigger-on-focus="false"
            clearable
            style="width:100%"
            @select="fillFromHistory"
          >
            <template slot-scope="{ item }">
              <span style="font-weight:600">{{ item.name }}</span>
              <span style="color:#999;margin-left:8px">{{ item.phone }}</span>
              <span v-if="item.idCard" style="color:#bbb;margin-left:8px;font-size:12px">{{ item.idCard }}</span>
            </template>
          </el-autocomplete>
        </div>

        <template v-if="orderType == 1 && form.ticketRestrictions == 1">
          <el-form-item label="联系电话" prop="customerPhone">
            <el-input placeholder="接收行程短信的手机号码" v-model="form.customerPhone" maxlength="11"></el-input>
          </el-form-item>

          <el-form-item label="购票数量" prop="passengerNum">
            <el-radio-group v-model="form.passengerNum" size="mini" @change="setPeople">
              <el-radio-button v-for="item in 8" :label="item" :key="item"></el-radio-button>
            </el-radio-group>
          </el-form-item>
        </template>

        <template v-if="orderType == 1 && form.ticketRestrictions == 2">
          <el-form-item label="乘客身份信息" prop="customers">
            <el-table class="customersTable" border empty-text="暂无数据" :data="form.customers">
              <el-table-column label="姓名" prop="name" v-slot="{ row }" width="100">
                <el-input v-model="row.name" maxlength="10" />
              </el-table-column>
              <el-table-column label="证件类型" prop="cardType" v-slot="{ row, $index }" width="160">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.cardType'">
                  <el-select v-model="row.cardType" placeholder="请选择证件类型" @change="row.idCard = ''">
                    <el-option v-for="(item, i) in $const.CARDTYPELIST" :key="i" :value="item.value"
                      :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-table-column>
              <el-table-column label="证件号码" prop="idCard" v-slot="{ row, $index }">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.idCard'" :rules="[{
                  pattern: $const.CARDRULES[row.cardType || 1].rules,
                  message: '请输入正确的证件号码',
                  trigger: ['blur', 'change'],
                  required: true
                }]">
                  <el-input v-model="row.idCard"
                    @input="row.idCard = row.idCard.toLocaleUpperCase(); $refs.form.validateField('customers')"
                    :maxlength="$const.CARDRULES[row.cardType || 1].maxLength" />
                </el-form-item>
              </el-table-column>
              <!-- <el-table-column label="身份证号码" prop="idCard" v-slot="{ row, $index }">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.idCard'" :rules="[{
                  pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                  message: '请输入正确的身份证号',
                  trigger: 'change'
                }]">
                  <el-input v-model="row.idCard"
                            @input="row.idCard = row.idCard.replace(/[^\dXx]/g, ''); $refs.form.validateField('customers')"
                            maxlength="18"/>
                </el-form-item>
              </el-table-column> -->
              <el-table-column label="手机号码" prop="phone" v-slot="{ row, $index }" width="140">
                <el-form-item class="checkItem" :prop="'customers.' + $index + '.phone'" :rules="[{
                  pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                  message: '请输入正确手机号',
                  trigger: 'change'
                }]">
                  <el-input v-model="row.phone"
                    @input="row.phone = row.phone.replace(/[^\d]/g, ''); $refs.form.validateField('customers')"
                    maxlength="11" />
                </el-form-item>
              </el-table-column>
              <el-table-column label="设为联系人" v-slot="{ $index }" width="82">
                <el-radio v-model="isDefault" :label="$index" @input="isDefaultChange" />
              </el-table-column>
              <el-table-column label="操作" v-slot="{ $index }" width="90">
                <el-button type="text" @click="deleteCustomer($index)">删除</el-button>
                <el-button type="text" @click="readCard($index)">读卡</el-button>
              </el-table-column>
            </el-table>
            <el-button v-show="form.customers && form.customers.length < 8" class="add" @click="addCustomer">
              <i class="el-icon-circle-plus-outline"></i> 添加
            </el-button>
          </el-form-item>
        </template>

        <template v-if="orderType == 2">
          <template v-if="form.ticketRestrictions == 2">
            <el-form-item label="乘客姓名" prop="customerName">
              <el-input placeholder="请输入乘客姓名" maxlength="11" v-model="form.customerName"></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="cardType">
              <el-select v-model="form.cardType" placeholder="请选择证件类型" @change="form.customerIdCard = ''">
                <el-option v-for="(item, i) in $const.CARDTYPELIST" :key="i" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="customerIdCard" :rules="[{
              pattern: $const.CARDRULES[form.cardType || 1].rules,
              message: '请输入正确的证件号码',
              trigger: ['blur', 'change'],
              required: true
            }]">
              <el-input v-model="form.customerIdCard"
                @input="form.customerIdCard = form.customerIdCard.toLocaleUpperCase(); $refs.form.validateField('customers')"
                :maxlength="$const.CARDRULES[form.cardType || 1].maxLength" />
            </el-form-item>
            <!-- <el-form-item label="身份证号" prop="customerIdCard">
              <el-input placeholder="与乘客身份证号一致" v-model="form.customerIdCard" maxlength="18"></el-input>
            </el-form-item> -->
          </template>
          <el-form-item label="联系电话" prop="customerPhone">
            <el-input placeholder="联系手机号码" v-model="form.customerPhone" maxlength="11"></el-input>
          </el-form-item>

        </template>

        <el-form-item label="下单备注" prop="remark">
          <el-input v-model="form.remark" maxlength="30"></el-input>
        </el-form-item>

        <el-form-item label="支付金额" prop="fee">
          <el-input :disabled="systemOrderFeeChange == 1 ? false : true" v-model="form.fee" maxlength="7"
            @input="form.fee = form.fee.replace(/[^\d]/g, '').replace(/^0[\d]/g, '0')">
            <template slot="append">元</template>
          </el-input>
          <p class="util-remark">支付金额将从机构余额扣除</p>
        </el-form-item>

        <el-form-item v-if="btnPreFn('driver_collection', false)" prop="remark" label-width="0">
          <el-checkbox :true-label="1" :false-label="2" v-model="form.driverCollection">司机代收款</el-checkbox>
          <p class="util-remark">勾选后，司机检票时需代收款，收款后将自动扣除司机余额</p>
        </el-form-item>
      </template>

    </el-form>

    <div class="orderForm-footer">
      <el-button @click="$router.back()" :loading="loading">取消</el-button>
      <el-button type="primary" @click="saveClick" :loading="loading">确定</el-button>
    </div>

    <orderFormMap v-if="mapVisible" :visible.sync="mapVisible" :address.sync="mapAddress" :type="mapType"
      :fences="fences" :lineId="form.lineId" :schedulingId="form.schedulingId" :lineType="lineInfo.lineType"
      :startRailNoSource="startRailNo" :endRailNoSource="endRailNo" @confirm="mapConfirm" @fee="fee"
      @startRailNo="start" @endRailNo="end" />
  </div>
</template>

<script>
import Decimal from "decimal.js";
import orderFormMap from "./orderFormMap";

export default {
  components: { orderFormMap },
  name: "orderForm",
  props: {
    copyPhone: {
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      ws: null,
      systemOrderFeeChange: "",

      mapVisible: false,
      mapType: 1,
      mapAddress: {},
      customersState: false,
      lineInfo: {},
      // 线路班次状态预加载（方案A）
      lineScheduleMap: {},
      scheduleMapLoading: false,
      // 线路加载状态
      linesLoading: false,
      // 表单
      form: {
        address: [{ type: 1 }, { type: 2 }],
        customers: [],
        ticketRestrictions: 1, // 购票限制：1-快捷购票，2-实名购票
        fee: null,
        schedulingId: null,
        lineId: null,
        customerName: null,
        customerIdCard: null,
        customerPhone: null,
        passengerNum: null,
        startAddress: null,
        endAddress: null,
        remark: null,
        driverCollection: 2,
        cardType: 1,
      },
      // 校验规则
      rules: {
        customerPhone: [
          { required: true, message: "请输入乘客联系电话" },
          { pattern: /^1\d{10}$/, message: "请输入正确的联系电话" },
        ],
        customerName: [{ required: true, message: '请输入乘客姓名', trigger: 'change' }],
        customerIdCard: [
          { required: true, message: '请输入身份证号', trigger: 'change' },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '请输入正确的身份证号'
          }
        ],
        passengerNum: [{ required: true, message: "请选择购票数量" }],
        customers: [{
          required: true,
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            if (!value || value.length == 0) {
              callback(new Error("请添加乘客信息"));
            } else {
              this.form.customers.find(item => {
                if (!item.name || !item.idCard || !item.phone) {
                  callback(new Error("请检查乘客身份信息否输入正确！"));
                  return true
                }
              })
              callback();
            }
          }
        }],
        startAddress: [
          {
            required: true,
            message: "请选择上车位置",
            trigger: ["blur", "change"],
          },
        ],
        endAddress: [
          {
            required: true,
            message: "请选择下车位置",
            trigger: ["blur", "change"],
          },
        ],
        lineId: [{ required: true, message: "请选择线路" }],
        fee: [{ required: true, message: "请输入支付金额", trigger: "blur" }],
        rentTimeValueArr: [{
          validator: (rule, value, callback) => {
            if (!(this.rentTimeValueArr[0] != null && this.rentTimeValueArr[1] != null && this.rentTimeValueArr[2] != null)) {
              callback(new Error("请选择完整的用车时间"));
              return;
            }
            let date = new Date(this.days[this.rentTimeValueArr[0]]);
            date.setHours(this.hours[Number(this.rentTimeValueArr[1])])
            date.setMinutes(this.minutes[Number(this.rentTimeValueArr[2])])
            date.setSeconds(0)
            date.setMilliseconds(0)
            if (date.getTime() < Date.now()) {
              callback(new Error("请选择大于当前时间的选值"));
            } else {
              this.form.serviceTime = date.getTime();
              callback();
            }
          }, required: true, trigger: 'change'
        }]
      },
      isDefault: 0,
      loading: false,
      // 菜单信息列表
      list: [],
      // 线路详情
      fences: [],
      lines: [],
      schedulings: [],
      startRailNo: null,
      endRailNo: null,

      orderType: 1,
      days: [],
      hours: [],
      minutes: ['00', '10', '20', '30', '40', '50'],
      rentTimeValueArr: [null, null, null],

      readIndex: null,
      readSwitch: false,
      historyKeyword: '',
    };
  },
  computed: {
    // 当前选中线路的班次摘要（方案B）
    scheduleSummary() {
      if (!this.form.lineId || !this.schedulings) return null;
      const items = this.schedulings.filter(s => s.schedulingTime); // 只展示普通班次
      return {
        total: items.length,
        items: items.slice(0, 8), // 最多显示8个
        remaining: items.reduce((sum, s) => sum + (s.ticketNumType == 1 ? 999 : (s.remainingTickets || 0)), 0)
      };
    },
    /* 是否显示地图上围栏相关的操作按钮 */
    startAddress() {
      let item = this.form.address.find((item) => item.type == 1);
      let name = item.name;
      this.$set(this.form, "startAddress", name);
      return name;
    },
    endAddress() {
      let item = this.form.address.find((item) => item.type == 2);
      let name = item.name;
      this.$set(this.form, "endAddress", name);
      return name;
    }
  },
  watch: {
    form(newval, oldval) {
      if (newval != oldval) {
        return null;
      }
    },
    "form.fee"(val) {
      if (typeof val == "undefined") {
        this.form.fee = null;
      }
    },
  },
  created() {
    this.getTicketRestrictions();
    this.getLines();
    this.connectionCardReader();
    if (this.copyPhone) {
      this.form.customerPhone = this.copyPhone
    }
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  },
  methods: {
    /* 连接读卡器 */
    connectionCardReader() {
      const webUrl = 'ws://' + '127.0.0.1:30004' + '/ws'
      this.ws = new WebSocket(webUrl)
      this.ws.onopen = () => {
        console.log('读卡器驱动websocket连接成功');
      }
      this.ws.onclose = () => {
        console.log('读卡器驱动websocket已断开')
      }
      this.ws.onmessage = (messageEvent) => {
        if (!this.readSwitch) return;
        const jsonobject = JSON.parse(messageEvent.data)
        if (jsonobject.Ret == 0) {
          if (jsonobject.Cmd == 10001) {
            const szparam = JSON.parse(window.atob(jsonobject.UserParam))

            let hex2a = (hex) => {
              let str_list = ''
              for (let i = 0; i < hex.length && hex.substr(i, 2) !== '00'; i += 2) {
                const a = hex.charCodeAt(i)
                const b = hex.charCodeAt(i + 1)
                const c = b * 256 + a
                str_list += String.fromCharCode(c)
              }
              return str_list.toString()
            }

            let parseDateString = (str, deco, zero) => {
              let year = str.substr(0, 4)
              let month = str.substr(4, 2)
              let date = str.substr(6)
              if (zero) {
                month = month.substr(0, 1) === "0" ? month.substr(1) : month
                date = date.substr(0, 1) === "0" ? date.substr(1) : date
              }
              return `${year}${deco}${month}${deco}${date}`
            }
            let birthday = hex2a(window.atob(szparam.CardInfo.Birthday))
            let birthArr = parseDateString(birthday, ".", true).split(".")

            let info = {
              name: hex2a(window.atob(szparam.CardInfo.Name)).trim(),
              number: hex2a(window.atob(szparam.CardInfo.No)),
              // sex: hex2a(window.atob(szparam.CardInfo.Sex)),
              // nation: hex2a(window.atob(szparam.CardInfo.Nation)),
              // birthday: hex2a(window.atob(szparam.CardInfo.Birthday)),
              // year: birthday[0],
              // month: birthArr[1],
              // date: birthArr[2],
              // address: hex2a(window.atob(szparam.CardInfo.Address)),

              // signedDepartment: hex2a(window.atob(szparam.CardInfo.SignedDepartment)).trim(),
              // validityPeriodBegin: hex2a(window.atob(szparam.CardInfo.ValidityPeriodBegin)),
              // validityPeriodEnd: hex2a(window.atob(szparam.CardInfo.ValidityPeriodEnd))
            }
            this.$set(this.form.customers[this.readIndex], 'name', info.name)
            this.$set(this.form.customers[this.readIndex], 'idCard', info.number)
            this.$set(this.form.customers[this.readIndex], 'cardType', 1)
            this.readSwitch = false;
          } else if (jsonobject.Cmd == 1000) {
            let szparam = JSON.parse(window.atob(jsonobject.UserParam));
            if (szparam.State == 0) {
              this.$message.info('读卡器已被拔出');
              this.readIndex = null;
              this.readSwitch = false;
            }
          }
        } else {
          this.$message.info('读卡失败，原因：' + jsonobject.ErrInfo);
        }
      }
    },
    /* 手动读卡 */
    cardReadInfo() {
      const szJson = '{"Cmd":10000,"Head":"YZWL","IPFlag":"MGEyZmU1NmY5ODZlZGMyNg==","UserParam":"eyJBcHBLZXkiOiI5OWZmYjJmOThhMjkwNzExMDdjN2EwOWFkMmM2ZDA5NiIsIkRlY29kZVBob3RvIjp0cnVlLCJGYWNlQ29tcGFyZSI6ZmFsc2UsIlBob3RvRm9ybWF0IjoxLCJTZXJ2ZXJJUCI6ImlkLnl6ZnV0dXJlLmNuIiwiU2VydmVyUG9ydCI6ODg0OH0NCg==","Version":"V1.0.0"}\n'
      this.ws.send(szJson)
    },
    fee(e) {
      this.lineInfo.fee = e;
    },
    start(e) {
      this.startRailNo = e;
    },
    end(e) {
      this.endRailNo = e;
    },
    changeAddress(mapType) {
      if (
        this.lineInfo.lineType == 1 ||
        (this.lineInfo.lineType == 2 && mapType == 1) ||
        (this.lineInfo.lineType == 4 && mapType == 2)
      ) {
        return;
      }
      if (
        mapType == 2 &&
        !this.startRailNo &&
        this.lineInfo.lineType != 1 &&
        this.lineInfo.lineType != 2
      ) {
        this.$message.info("请先选择上车点");
        return;
      }
      this.mapType = mapType;
      this.mapVisible = true;
      this.mapAddress = this.form.address
        ? this.form.address.find((item) => item.type == mapType)
        : {};
    },

    refresh() {
      this.getTicketRestrictions();
      this.getLines();
      this.$refs.form.resetFields();
      this.orderType = 1;
      this.form.customers = [];
      this.form.address = [{ type: 1 }, { type: 2 }];
      this.form.driverCollection = 2;
      this.form.cardType = 1;
      this.schedulings = [];
      this.lineInfo = {};
    },

    /* 获取基础配置详情 */
    async getTicketRestrictions() {
      let url = "/api/v1/manage/order/manage/querySystemsConfig";
      let data = await this.$axios.get(url);
      if (data?.code == 1 && data.data) {
        this.systemOrderFeeChange = data.data.systemOrderFeeChange;
      }
    },

    customersConfirm(customers) {
      this.$set(this.form, "customers", customers);
      this.$refs.form.validateField("customers");
    },

    mapConfirm(obj) {
      let address = this.form.address;
      address = address.map((item) => {
        if (item.type == this.mapType) {
          item = obj;
        }
        return item;
      });
      this.form.address = address;

      this.$set(this.form, this.mapType == 1 ? "startAddress" : "endAddress", obj);
      this.$refs.form.validateField(this.mapType == 1 ? "startAddress" : "endAddress");

      this.setPeople();
    },

    /* 线路变更 */
    async lineChange(val) {
      this.startRailNo = null;
      this.endRailNo = null;
      this.$set(this.form, "schedulingId", "");
      this.schedulings = [];
      if (val) {
        await this.getScheduling(val);
        let item = this.lines.find((item) => item.id == val);
        if (item) {
          this.form.ticketRestrictions = item.ticketRestrictions;
          this.lineInfo = item;
        } else {
          this.lineInfo = {};
        }
        this.getFence(val);
      }
      this.$nextTick(() => {
        this.$refs.form.validate(() => {});
      })
    },

    async getFence(lineId) {
      let url = "/api/v1/manage/order/manage/fence";
      let params = {
        lineId,
        appKey: this.mixinUserInfo?.appKey,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        let lineType = this.lineInfo.lineType;
        let address = [{ type: 1 }, { type: 2 }];
        switch (lineType) {
          // 站点-站点
          case 1:
            this.startRailNo = data.data[0].stationRail[0].railNo;
            this.endRailNo = data.data[1].stationRail[0].railNo;
            address = data.data.map((dataItem) => {
              dataItem = {
                type: dataItem.stationRail[0].type,
                city: dataItem.stationRail[0].city,
                longitude: dataItem.stationRail[0].longitude,
                latitude: dataItem.stationRail[0].latitude,
                name: dataItem.stationRail[0].stationName,
                address: dataItem.stationRail[0].stationAddress,
              };
              return dataItem;
            });
            break;
          // 站点-送人
          case 2:
            let dataItem2 = data.data.find((item) => item.type == 1);

            this.startRailNo = data.data[0].stationRail[0].railNo;
            address = address.map((item) => {
              if (item.type == 1) {
                item = {
                  type: item.type,
                  city: dataItem2.stationRail[0].city,
                  longitude: dataItem2.stationRail[0].longitude,
                  latitude: dataItem2.stationRail[0].latitude,
                  name: dataItem2.stationRail[0].stationName,
                  address: dataItem2.stationRail[0].stationAddress,
                };
              }
              return item;
            });
            break;
          // 接人-站点
          case 4:
            let dataItem4 = data.data.find((item) => item.type == 2);
            // this.endRailNo = data.data[1].stationRail[0].railNo;
            address = address.map((item) => {
              if (item.type == 2) {
                item = {
                  type: item.type,
                  city: dataItem4.stationRail[0].city,
                  longitude: dataItem4.stationRail[0].longitude,
                  latitude: dataItem4.stationRail[0].latitude,
                  name: dataItem4.stationRail[0].stationName,
                  address: dataItem4.stationRail[0].stationAddress,
                };
              }
              return item;
            });
            break;
        }
        this.form.address = address;
        this.fences = data.data || [];
      }
      this.$nextTick(() => {
        this.$refs.form.validate(() => {
        });
      })
    },

    schedulingFocus() {
      if (!this.form.lineId) {
        this.$message.warning("请先选择线路");
      }
    },

    /* 线路详情 */
    async getLines() {
      this.linesLoading = true;
      let url = "/api/v1/manage/order/manage/line";
      let data = await this.$axios.get(url);
      this.linesLoading = false;
      if (data && data.code == 1) {
        this.lines = data.data || [];
        // 方案A：预加载所有线路的班次摘要状态
        this.preloadScheduleMap();
      }
    },

    /* 方案A：预加载所有线路今日班次状态 */
    async preloadScheduleMap() {
      const validLines = this.lines.filter(l => l.schedulingType != 3);
      if (validLines.length === 0) return;
      this.scheduleMapLoading = true;
      const mapResult = {};
      // 并发请求，最多同时10条
      const batchSize = 10;
      for (let i = 0; i < validLines.length; i += batchSize) {
        const batch = validLines.slice(i, i + batchSize);
        await Promise.all(batch.map(async (line) => {
          try {
            const res = await this.$axios.get('/api/v1/manage/order/manage/scheduling/new', {
              lineId: line.id,
              appKey: this.mixinUserInfo?.appKey
            });
            if (res && res.code == 1) {
              const vos = res.data.schedulingVos || [];
              const total = vos.length;
              const remaining = vos.reduce((s, v) => s + (v.ticketNumType == 1 ? 999 : (v.remainingTickets || 0)), 0);
              this.$set(this.lineScheduleMap, line.id, { total, remaining });
            } else {
              this.$set(this.lineScheduleMap, line.id, { total: 0, remaining: 0 });
            }
          } catch (e) {
            this.$set(this.lineScheduleMap, line.id, { total: 0, remaining: 0 });
          }
        }));
      }
      this.scheduleMapLoading = false;
    },

    /* 班次摘要快速选择 */
    quickSelectScheduling(s) {
      this.form.schedulingId = s.id;
      this.schedulingChange(s.id);
    },

    /* 班次列表 */
    async getScheduling(lineId) {
      let url = "/api/v1/manage/order/manage/scheduling/new";
      let params = { lineId, appKey: this.mixinUserInfo?.appKey };
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        this.schedulings = (data.data.intercityVos || []).concat(data.data.schedulingVos || []);
        // 更新方案A中该线路的班次状态缓存
        const vos = data.data.schedulingVos || [];
        const total = vos.length;
        const remaining = vos.reduce((s, v) => s + (v.ticketNumType == 1 ? 999 : (v.remainingTickets || 0)), 0);
        this.$set(this.lineScheduleMap, lineId, { total, remaining });
      }
    },

    /* 班次变更 */
    async schedulingChange(val) {
      let item = this.schedulings.find((item) => item.id == val);
      if (item) {
        this.$set(this.form, "schedulingId", item.id);
        this.$set(this.form, "endTime", item.endTime);
        this.$set(this.form, "startTime", item.startTime);
        this.$set(this.form, "cardType", 1);

        if (item.schedulingTime) {
          if (this.orderType == 2) {
            this.$set(this.form, "fee", null);
          }
          this.orderType = 1; // 有schedulingTime就是1
          this.$set(this.form, "schedulingTime", item.schedulingTime);
        } else {
          this.orderType = 2;
          this.$set(this.form, "passengerNum", 1);
          this.$set(this.form, "serviceFee", item.serviceFee);
          this.$set(this.form, "fee", item.serviceFee);
          this.$set(this.form, "lineIntercityId", item.id);
          this.$set(this.form, "intercityName", item.intercityName);
          this.$set(this.form, "vehicleSeat", item.vehicleSeat);
          this.$refs.form.clearValidate("passengerNum");
          this.getRentTime(item);
        }
        if (this.startRailNo && this.endRailNo) {
          let url = "/api/v1/manage/order/manage/queryStartRailFee";
          let params = {
            type: 2,
            startRailNo: this.startRailNo,
            endRailNo: this.endRailNo,
            lineId: this.form.lineId,
            schedulingId: this.form.schedulingId,
            appKey: this.mixinUserInfo?.appKey,
          };
          let data = await this.$axios.get(url, params);
          if (data && data.code === 1) {
            this.$set(this.form, "fee", data.data.fee);
          }
        }



        this.$nextTick(() => {
          this.$refs.form.validate(() => {
          });
          !this.form.customers.length && this.addCustomer()
        })
      }
    },

    /* 获取用车日期 初始化用车时间 */
    async getRentTime(item) {
      let url = "/api/v1/manage/order/manage/intercity/time/" + this.form.lineId;
      let data = await this.$axios.get(url, { appKey: this.mixinUserInfo?.appKey });
      if (data && data.code == 1) {
        let days = [];
        data.data.map(time => {
          time = new Date(time * 1000).toLocaleDateString();
          days.push(time)
        })
        this.days = days;
      }

      let supplementZero = (val) => val < 10 ? ('0' + val) : String(val)
      let hours = [];
      for (let i = Number(item.startTime.slice(0, 2)); i <= Number(item.endTime.slice(0, 2)); i++) {
        hours.push(supplementZero(Number(i)))
      }
      this.hours = hours;
    },

    /* 用车时间Change */
    rentTimeChange() {
      if (this.rentTimeValueArr[1] == this.hours.length - 1) {
        this.rentTimeValueArr[2] = 0
        this.minutes = ['00']
      } else {
        this.minutes = ['00', '10', '20', '30', '40', '50']
      }
    },

    /* 修改人数 */
    setPeople() {
      if (!this.form.passengerNum) return;
      if (this.lineInfo.fee || this.form.serviceFee) {
        if (this.orderType == 1) {
          // this.form.fee = ((this.lineInfo.fee * 100 * this.form.passengerNum) / 100).toFixed(2);
          this.form.fee = new Decimal(this.lineInfo.fee).mul(new Decimal(this.form.passengerNum)).toNumber();
        } else {
          // this.form.fee = ((this.form.serviceFee * 100 * this.form.passengerNum) / 100).toFixed(2);
          this.form.fee = new Decimal(this.form.serviceFee).mul(new Decimal(this.form.passengerNum)).toNumber();
        }
        this.$refs.form.validateField("fee");
      }
    },

    /* 添加实名乘客 */
    addCustomer() {
      this.form.customers.push({ cardType: 1, idCard: "" });

      if (this.form.customers.length == 1) {
        this.form.customers[0].isDefault = 1;
      } else {
        this.form.customers[this.form.customers.length - 1].isDefault = 2;
      }
      this.form.fee = new Decimal(this.lineInfo.fee).mul(new Decimal(this.form.customers.length)).toNumber();
      this.form.passengerNum = this.form.customers.length;
      this.$refs.form.validateField("fee");
    },

    /* 删除实名乘客 */
    deleteCustomer(index) {
      this.form.customers.splice(index, 1)
      this.form.fee = new Decimal(this.lineInfo.fee).mul(new Decimal(this.form.customers.length)).toNumber();
      this.form.passengerNum = this.form.customers.length;
      this.$refs.form.validateField('customers');
      if (index == this.isDefault) {
        this.isDefault = 0;
        if (this.form.customers.length > 0) {
          this.isDefaultChange(0)
        }
      } else if (index < this.isDefault) {
        this.isDefault -= 1;
      }
    },

    /* 修改默认联系人 */
    isDefaultChange(index) {
      this.form.customers.map((item, i) => {
        if (index == i) {
          item.isDefault = 1
        } else {
          item.isDefault = 2
        }
      })
    },

    /* 读卡 */
    readCard(index) {
      this.readIndex = index;
      this.readSwitch = true;
      this.cardReadInfo();
    },

    /* 实名校验 */
    async realName() {
      let params = {
        name: this.form.customerName,
        idCard: this.form.customerIdCard,
        lineId: this.form.lineId,
        appKey: this.mixinUserInfo?.appKey,
      };
      let data = await this.$axios.post("/api/v1/manage/order/manage/customer/realName", params);
      if (data && data.code === 1) {
        return true
      } else {
        return false
      }
    },

    /* 点击保存 */
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {

          let bl = false;
          let repeatIdCard = [];
          this.form.customers.map(item => {
            if (repeatIdCard.includes(item.idCard)) {
              bl = true;
            } else {
              repeatIdCard.push(item.idCard)
            }
          })
          if (bl) {
            this.$message.info('乘客证件号码不可重复')
            return;
          }

          if (this.orderType == 2 && this.form.cardType == 1 && this.form.ticketRestrictions != 1) {
            bl = await this.realName();
            if (!bl) {
              return;
            }
          }

          let params = this.$utils.deepCopyFn(this.form);

          params.customers = params.customers ? JSON.stringify(params.customers) : [];
          params.address = params.address ? JSON.stringify(params.address) : [];
          params.orderFee = this.form.fee;
          params.railFee = this.lineInfo.fee;
          params.endRailNo = this.endRailNo;
          params.startRailNo = this.startRailNo;

          delete params.startAddress;
          delete params.endAddress;
          this.postFn(params);
        }
      });
    },

    /* 接口请求-提交 */
    async postFn(params) {
      this.loading = true;
      let url = this.orderType == 1 ? "/api/v1/manage/order/manage" : "/api/v1/manage/order/manage/intercity";
      let data = await this.$axios.post(url, params);
      this.loading = false;

      if (data && data.code == 1) {
        this.$message.success('下单成功');
        // this.print();
        this.form = {
          address: [{ type: 1 }, { type: 2 }],
          customers: [],
          ticketRestrictions: 1,
          fee: null,
          schedulingId: null,
          lineId: null,
          customerName: null,
          customerIdCard: null,
          customerPhone: null,
          passengerNum: null,
          startAddress: null,
          endAddress: null,
          remark: null,
        };
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['lineId', 'schedulingId']);
        })
        this.getTicketRestrictions();
        this.getLines();
        this.schedulings = [];
        this.lineInfo = {};
        this.orderType = 1;
        this.isDefault = 0;
        this.rentTimeValueArr = [null, null, null]
        if (this.copyPhone) {
          this.$emit("callCatPaOSuccess");
        }
      } else if (data.code == 50048 || data.code == 50160) {
        this.refresh();
      }
    },

    /* 历史乘客搜索 - el-autocomplete fetch-suggestions 回调 */
    async searchHistoryCustomers(keyword, cb) {
      if (!keyword || keyword.trim().length < 1) {
        cb([]);
        return;
      }
      try {
        const url = '/api/v1/manage/order/manage/customer/history';
        const { code, data } = await this.$axios.get(url, {
          appKey: this.mixinUserInfo?.appKey,
          keyword: keyword.trim(),
        });
        if (code === 1 && data && data.length > 0) {
          cb(data.map(item => ({ ...item, value: item.name + ' ' + item.phone })));
        } else {
          cb([]);
        }
      } catch (e) {
        cb([]);
      }
    },

    /* 历史乘客选填 - 根据 ticketRestrictions 填充对应字段 */
    fillFromHistory(item) {
      if (this.form.ticketRestrictions == 1) {
        // 快捷购票：仅填手机号
        this.$set(this.form, 'customerPhone', item.phone || '');
      } else {
        // 实名购票
        if (this.orderType == 2) {
          // 专线包车：单乘客
          this.$set(this.form, 'customerName', item.name || '');
          this.$set(this.form, 'customerPhone', item.phone || '');
          if (item.idCard) this.$set(this.form, 'customerIdCard', item.idCard);
          if (item.cardType) this.$set(this.form, 'cardType', item.cardType);
        } else {
          // 普通班车实名：添加到乘客列表
          const customer = {
            name: item.name || '',
            phone: item.phone || '',
            idCard: item.idCard || '',
            cardType: item.cardType || 1,
            isDefault: this.form.customers.length === 0 ? 1 : 2,
          };
          this.form.customers.push(customer);
          this.form.fee = new Decimal(this.lineInfo.fee || 0)
            .mul(new Decimal(this.form.customers.length))
            .toNumber();
          this.form.passengerNum = this.form.customers.length;
          this.$refs.form && this.$refs.form.validateField('fee');
        }
      }
      this.historyKeyword = '';
      this.$message.success('已填充乘客信息：' + item.name);
    },

    /* 打印发票 */
    print() {

      // html2canvas(document.querySelector('#print')).then(canvas => {
      //   const imgUrl = canvas.toDataURL('image/jpeg')
      //   const image = document.createElement('img')
      //   image.src = imgUrl
      //   // 将生成的图片放到 类名为 content 的元素中
      //   document.querySelector('#print').appendChild(image)
      //   const a = document.createElement('a')
      //   a.href = imgUrl
      //   // a.download 后面的内容为自定义图片的名称
      //   a.download = 'study_download'
      //   a.click()
      // })

      // return;

      this.$nextTick(() => {
        const printContentHtml = document.getElementById("print").innerHTML;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.contentDocument.write(printContentHtml);
        iframe.contentDocument.close();
        iframe.contentWindow.print();
      })
    },
  }
};
</script>

<style lang="less">
#orderForm {
  height: 100%;
  box-sizing: border-box;
  color: #303133;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-y: auto;
  background: #f5f6fa;

  &>* {
    width: 1000px;
    margin-top: 16px;
    padding: 20px 28px;
    border-radius: 12px;
    background-color: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
  }

  // 返回按钮
  .orderForm-header {
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    color: #606266;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 0;

    i { font-size: 16px; }

    &:hover {
      color: #409EFF;
      background: #ecf5ff;
    }
  }

  // 标题区域
  .orderForm-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;

    .title-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .title-icon {
        font-size: 24px;
        color: #409EFF;
      }

      .title-text {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        display: block;
      }

      .title-sub {
        font-size: 13px;
        color: #909399;
        display: block;
        margin-top: 2px;
      }
    }
  }

  // 提示栏
  .notice-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #ecf5ff;
    border-radius: 6px;
    border: 1px solid #b3d8ff;
    color: #409EFF;
    font-size: 13px;
    margin-bottom: 20px;
  }

  // 线路下拉选项
  .line-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;

    .line-option-main {
      display: flex;
      align-items: center;
      gap: 8px;

      .line-name {
        font-size: 14px;
        color: #303133;
        font-weight: 500;
      }
    }

    .line-option-sub {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 12px;

      .line-fee {
        color: #F56C6C;
        font-weight: 600;
      }

      .line-seats {
        color: #67C23A;

        &.low-seats {
          color: #E6A23C;
          font-weight: 600;
        }
      }
    }
  }

  // 班次摘要卡片（方案B）
  .schedule-summary {
    margin: 0;
    padding: 16px 20px;
    background: #f8faff;
    border: 1px solid #d9e8ff;
    border-radius: 8px;
    box-shadow: none;
    margin-bottom: 16px;

    .summary-header {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      font-weight: 600;
      color: #409EFF;
      margin-bottom: 12px;
    }

    .summary-empty {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #F56C6C;
      font-size: 13px;
      padding: 8px 0;

      i { font-size: 16px; }
    }

    .summary-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .summary-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px;
        background: #fff;
        border: 1px solid #dde3f0;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 13px;

        &:hover {
          border-color: #409EFF;
          background: #ecf5ff;
        }

        &.item-disabled {
          opacity: 0.5;
          cursor: not-allowed;
          &:hover { border-color: #dde3f0; background: #fff; }
        }

        .summary-item-time {
          display: flex;
          align-items: center;
          gap: 6px;

          .time-badge {
            font-weight: 600;
            color: #303133;
          }
        }

        .summary-item-date {
          color: #909399;
          font-size: 12px;
        }
      }
    }
  }

  // 班次下拉选项
  .scheduling-option {
    padding: 4px 0;

    .sch-main {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 2px;

      .sch-date {
        font-weight: 600;
        color: #303133;
        font-size: 13px;
      }

      .sch-time {
        color: #606266;
        font-size: 13px;
      }

      .sch-name {
        color: #303133;
        font-size: 13px;
        font-weight: 500;
      }
    }

    .sch-sub {
      display: flex;
      align-items: center;
      gap: 12px;

      .sch-seat {
        font-size: 12px;
        color: #67C23A;

        &.seat-low { color: #E6A23C; font-weight: 600; }
        &.seat-out { color: #C0C4CC; }
      }

      .sch-fee {
        font-size: 12px;
        color: #F56C6C;
        font-weight: 600;
      }
    }
  }

  // 历史乘客搜索
  .history-customer-search {
    margin-bottom: 18px;
    padding: 12px 16px;
    background: #f8f9fc;
    border-radius: 8px;
    border: 1px solid #e8eaf0;

    .history-search-label {
      font-size: 13px;
      color: #606266;
      margin-bottom: 8px;
      font-weight: 500;
    }

    .el-autocomplete {
      width: 100%;
    }
  }

  // 底部按钮（sticky）
  .orderForm-footer {
    text-align: right;
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: #fff;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    margin-top: 0;
  }

  .customersTable {
    .el-table__row .el-table__cell {
      padding: 0;

      .cell {
        height: 60px;
        line-height: 60px;
      }
    }
  }

  .checkItem {
    height: 60px !important;
    margin-bottom: 0 !important;

    .el-form-item__content {
      line-height: 58px;
    }

    .el-form-item__error {
      top: unset;
      bottom: 0 !important;
    }
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-radio__label {
    display: none;
  }

  .time {
    width: 100%;
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 10px;
  }

  .add {
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    border: 1px #dcdfe6 dashed;
    border-radius: 6px;
    color: #909399;

    &:hover {
      border-color: #409EFF;
      color: #409EFF;
    }
  }

  .el-form-item-remark {
    font-size: 12px;
    color: #909399;
    margin-left: 8px;
  }
}
</style>
